import { Crown } from "lucide-react";

/** The viewer's relationship to a meeting — organizer beats participant; null hides the badge. */
export type Involvement = "organizer" | "participant" | null;

/** Color-coded involvement chip — lavender crown for organizer, green dot for participant. */
export function RoleBadge({ role }: { role: Involvement }) {
	if (role === "organizer") {
		return (
			<span className="inline-flex flex-none items-center gap-1 rounded-full border border-primary/40 bg-primary/15 px-1.5 py-0.5 text-meta font-medium text-primary-hover">
				<Crown className="size-2.5" />
				Organizer
			</span>
		);
	}
	if (role === "participant") {
		return (
			<span className="inline-flex flex-none items-center gap-1 rounded-full border border-semantic-success/30 bg-semantic-success/10 px-1.5 py-0.5 text-meta font-medium text-semantic-success">
				<span className="size-1.5 rounded-full bg-semantic-success" />
				Participant
			</span>
		);
	}
	return null;
}
